module.exports = function() {
  return new Worker(__webpack_public_path__ + "94f29b7cf5e06721e641.worker.js");
};